import React from "react";

const PaymentAvailableInProduct = () => {
  return (
    <>
      <h5> Guarantee safe & Secure checkout </h5>
      <div className="payment-methods">
        <img src="/images/Apple Pay.svg" alt="payment methods" />
        <img src="/images/Mastercard.svg" alt="payment methods" />
        <img src="/images/Google Pay.svg" alt="payment methods" />
        <img src="/images/Amazon.svg" alt="payment methods" />
        <img src="/images/Dogecoin.svg" alt="payment methods" />
        <img src="/images/Diners Club.svg" alt="payment methods" />
        <img src="/images/Bitcoin.svg" alt="payment methods" />
        <img src="/images/Diners Club.svg" alt="payment methods" />
        <img src="/images/Amazon.svg" alt="payment methods" />
        <img src="/images/American Express.svg" alt="payment methods" />
      </div>
    </>
  );
};

export default PaymentAvailableInProduct;
